export const recenterMap = () => ({
  type: "RECENTER_MAP"
})

export const setMapBounds = (minLat, minLong, maxLat, maxLong) => ({
  type: "SET_MAP_BOUNDS",
  bounds: [[minLat, minLong], [maxLat, maxLong]]
})

export function propertySearch(text) {
  return (dispatch, getState) => {
    const state = getState();
    var property = state.DataApp.get('filteredProperties').filter(x => x.get('cty_tmk') === text); 
    if(property.size > 0) {
      dispatch({type: "FIND_PROPERTY", property: text});
    } else {
      dispatch({type: "LOSE_PROPERTY"});
      dispatch({type: "DATA_ERROR", message: 'Location not shown or not found.'})
    }
  }
}

export const loseProperty = () => ({
  type: "LOSE_PROPERTY"
})

export const chooseProperty = (property) => ({
  type: "CHOOSE_PROPERTY",
  property
})

/*export const createdPolygon = (id, polygon, layer) => ({
  type: "POLYGON_CREATED",
  id,
  polygon,
  layer
})

export const deletedPolygon = (ids) => ({
  type: "POLYGON_DELETED",
  ids
})

export const resetPolygons = (data) => ({
  type: "POLYGON_RESET",
  data
})*/

export const viewpointChange = (viewpoint) => ({
  type: "VIEWPOINT_CHANGE",
  viewpoint
})




// WEBPACK FOOTER //
// ./src/actions/map.js